import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../../../auth";
import { Documente } from "../views";
import DocumentDetailsPage from "../components/DocumentProcessPage";

const DocumenteRoutes = () => {
  const user= useAuth();

  return (
    <Routes>
      <Route path="/" element={<Documente />} />
      <Route path=":documentId" element={<DocumentDetailsPage />} />
      {/* <Route path="*" element={<Navigate to="/" />} /> */}
    </Routes>
  );
};

export default DocumenteRoutes;
